export default __webpack_public_path__ + "static/media/turkey.05e7cf63.svg";